export const siteContent = {
  organization: {
    name: 'Korea Aerospace University LIKELION',
    nameKr: '한국항공대학교 멋쟁이사자처럼',
    shortName: 'KAU LIKELION',
    slogan: 'POSSIBILITY TO REALITY',
    motto: '내 아이디어를 내 손으로 실현한다',
    description: '웹 개발 & IT 창업 동아리',
    address: '경기도 고양시 덕양구 항공대학로 76',
  },

  about: {
    description: [
      '멋쟁이사자처럼은 현재 전국 약 80개 대학이 함께하고 있는 연합 동아리입니다.',
      '한국항공대학교 멋사는 "내 아이디어를 내 손으로 실현한다"라는 슬로건 아래, 웹 개발을 배우고 프로젝트를 수행합니다.',
      '한국항공대학교 멋사의 선발기준에 코딩 실력은 \'절대\' 없습니다!',
      '전공, 학년, 나이에 제한 없이 한국항공대학교 학생이라면 재학생, 휴학생 무관 누구나 가입할 수 있습니다!',
    ],
  },

  navigation: {
    home: { label: '홈', path: '/' },
    about: { label: '소개', path: '/about' },
    projects: { label: '프로젝트', path: '/projects' },
  },

  footer: {
    copyright: '© Korea Aerospace University LIKELION 13th President Ari All rights reserved.',
    socialLinks: {
      github: 'https://github.com/kau-likelion',
      instagram: 'https://instagram.com/kau_likelion',
    },
  },

  hero: {
    mainTitle: 'POSSIBILITY TO REALITY',
    subtitle: '한국항공대학교 멋쟁이사자처럼',
    flightSearch: {
      departure: 'Korea Aerospace Univ.',
      arrival: 'LIKELION 14th',
      date: '2026-03-13',
    },
  },
};
